import * as React from 'react';
import style from './skeletons.scss';
import {
  IndexPageSkeletonFirstColumn,
  IndexPageSkeletonSecondColumn,
} from './skeletonsPartials';
import classnames from 'classnames';
import { Skeleton } from 'wix-style-react';

export const RelatedSitesSkeleton = React.memo(({ className }) => (
  <div className={`${style.relatedSitesSkeleton} ${className}`}>
    <div className={style.skeletonContainer}>
      <Skeleton
        dataHook="related-sites-skeleton"
        content={[
          {
            size: 'full',
            type: 'line',
          },
        ]}
      />
    </div>
  </div>
));

export const DefaultSkeleton = React.memo(() => (
  <Skeleton
    content={[
      {
        size: 'small',
        type: 'line',
      },
      {
        size: 'large',
        type: 'line',
      },
      {
        size: 'medium',
        type: 'line',
      },
      {
        size: 'full',
        type: 'line',
      },
    ]}
  />
));

export const ArticlePageSkeleton = React.memo(() => {
  return (
    <Skeleton
      className={style.articleSkeleton}
      spacing="small"
      content={[
        {
          size: 'large',
          type: 'line',
        },
        {
          size: 'full',
          type: 'line',
        },
        {
          size: 'small',
          type: 'line',
        },
      ]}
    />
  );
});

export const ExamplesTableSkeleton = () => {
  return (
    <div className={style.examplesTableSkeletonWrapper}>
      <Skeleton
        className={classnames({
          [style.noBackground]: true,
          [style.fullWidth]: true,
        })}
        spacing="small"
        content={[
          {
            size: 'full',
            type: 'line',
          },
          {
            size: 'full',
            type: 'line',
          },
          {
            size: 'full',
            type: 'line',
          },
        ]}
      />
    </div>
  );
};

export const IndexPageSkeleton = React.memo(
  () => {
    return (
      <div className={style.indexPageSkeleton}>
        <Skeleton
          className={style.firstColumn}
          content={[
            {
              size: 'medium',
              type: 'line',
            },
          ]}
        />

        <div className={style.tableSkeletonWrapper}>
          <IndexPageSkeletonFirstColumn />
          <IndexPageSkeletonSecondColumn />
        </div>
      </div>
    );
  },
  () => true,
);
